module.exports = __webpack_public_path__ + "assets/39fe0a1ae4557f524ac58aaf28119218.svg";